import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold");
  const _component_el_icon = _resolveComponent("el-icon");
  return $data.showButton ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.scrollToTop && $options.scrollToTop(...args)),
    class: "scroll-to-top",
    style: _normalizeStyle({
      bottom: $props.bottom + 'px',
      right: $props.right + 'px',
      backgroundColor: $props.bgColor
    })
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowUpBold)]),
    _: 1
  })], 4)) : _createCommentVNode("", true);
}